import { render, staticRenderFns } from "./ProcessResource.vue?vue&type=template&id=e845bb3a&scoped=true"
import script from "./ProcessResource.vue?vue&type=script&lang=js"
export * from "./ProcessResource.vue?vue&type=script&lang=js"
import style0 from "./ProcessResource.vue?vue&type=style&index=0&id=e845bb3a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e845bb3a",
  null
  
)

export default component.exports